import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { CountryDataForm, CountryFilters } from '../../models/Country';


const useCountryService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetCountries, setFetchingGetCountries] = useState(false);
    const [fetchingCreateCountry, setFetchingCreateCountry] = useState(false);
    const [fetchingStoreCountry, setFetchingStoreCountry] = useState(false);
    const [fetchingEditCountry, setFetchingEditCountry] = useState(false);
    const [fetchingUpdateCountry, setFetchingUpdateCountry] = useState(false);
    const [fetchingDeleteCountry, setFetchingDeleteCountry] = useState(false);
    const [fetchingActiveCountry, setFetchingActiveCountry] = useState(false);
    const [fetchingGetRegionsByCountry, setFetchingGetRegionsByCountry] = useState(false);

    const getCountries = (filter: CountryFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filter)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        doGet({
            ...events,
            url: `${EndPoints.COUNTRY.GET_COUNTRIES}?${queryString}`,
            setFetching: setFetchingGetCountries
        });
    };

    const createCountry = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.COUNTRY.CREATE_COUNTRY,
            setFetching: setFetchingCreateCountry
        });
    };

    const storeCountry = (country: CountryDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.COUNTRY.STORE_COUNTRY,
            body: country,
            setFetching: setFetchingStoreCountry
        });
    };

    const editCountry = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.COUNTRY.EDIT_COUNTRY.replace(':id', id.toString()),
            setFetching: setFetchingEditCountry
        });
    };

    const updateCountry = (id: number, country: CountryDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.COUNTRY.UPDATE_COUNTRY.replace(':id', id.toString()),
            body: country,
            setFetching: setFetchingUpdateCountry
        });
    };

    const deleteCountry = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.COUNTRY.DELETE_COUNTRY.replace(':id', id.toString()),
            setFetching: setFetchingDeleteCountry
        });
    };

    const getRegionsByCountry = (countryId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.REGIONS.GET_REGIONS_BY_COUNTRY.replace(':country_id', countryId.toString()),
            setFetching: setFetchingGetRegionsByCountry
        });
    };

    const activeCountry = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.COUNTRY.ACTIVE_COUNTRY.replace(':id', id.toString()),
            body: { active },
            setFetching: setFetchingActiveCountry
        });
    };

    return {
        fetchingGetCountries,
        fetchingCreateCountry,
        fetchingStoreCountry,
        fetchingEditCountry,
        fetchingUpdateCountry,
        fetchingDeleteCountry,
        fetchingActiveCountry,
        fetchingGetRegionsByCountry,
        getCountries,
        createCountry,
        storeCountry,
        editCountry,
        updateCountry,
        deleteCountry,
        activeCountry,
        getRegionsByCountry
    };
};

export default useCountryService;
